/**
 * Partner iframe embed config (ported from legacy EmbedController::initPartnerEmbed).
 */
export const partnerEmbedConfigs = {
  'dv-asia': {
    referralCode: '6003kjuea',
    partnerName: 'DV ASIA',
    locale: 'zh-hant',
  },
  'ae-style': {
    referralCode: '5906fwxhw',
    partnerName: 'After Effects Style',
    locale: 'ja',
  },
  mydesy: {
    referralCode: '6008arhew',
    partnerName: 'MyDesy',
    locale: 'zh-hant',
  },
  huber: {
    referralCode: '6250ngmht',
    partnerName: '六指淵',
    locale: 'zh-hant',
  },
  openspc: {
    referralCode: '6174camwz',
    partnerName: 'OpenSpace',
    locale: 'ja',
  },
  'soundeffect-lab': {
    referralCode: '6193tzmkn',
    partnerName: '効果音ラボ',
    locale: 'ja',
  },
  moviepress: {
    referralCode: '6212hwnpa',
    partnerName: 'MoviePress',
    locale: 'ja',
  },
  'ae-study': {
    referralCode: '6248atkth',
    partnerName: 'AE Study',
    locale: 'ja',
  },
};

export function getPartnerEmbedConfig(partnerCode) {
  if (!partnerCode) {
    return null;
  }
  return partnerEmbedConfigs[partnerCode.toLowerCase()] || null;
}
